import { Mail, Send } from "lucide-react";

const STATUS = {
  sent: ["bg-emerald-100 text-emerald-800", "e-posta gönderildi"],
  failed: ["bg-red-100 text-red-800", "e-posta gönderilemedi"],
  queued: ["bg-slate-100 text-slate-700", "e-posta kuyrukta"],
};

// Şube onayı bekleyen kayıt: yetkiliye giden son e-postanın durumu + yeniden gönder (yönetici)
export default function ApprovalMailStatus({ r, isAdmin, onResend }) {
  if (r.waiting_on !== "sube") return null;
  const [cls, label] = STATUS[r.mail_status] || [];
  return (
    <span className="inline-flex items-center gap-1 flex-wrap">
      {label && (
        <span data-testid={`appr-mail-${r.id}`} title={[r.mail_to, r.mail_error].filter(Boolean).join(" · ")} className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-bold ${cls}`}>
          <Mail className="w-3 h-3" /> {label}
        </span>
      )}
      {isAdmin && r.waiting_name && (
        <button type="button" onClick={(e) => { e.stopPropagation(); onResend(r); }} data-testid={`appr-resend-mail-${r.id}`} title={`${r.waiting_name} adresine onay e-postasını ${r.mail_status === "sent" ? "yeniden " : ""}gönder`}
          className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded border border-sky-400 text-sky-800 bg-white text-[10px] font-semibold hover:bg-sky-50">
          <Send className="w-3 h-3" /> {r.mail_status === "sent" ? "Yeniden Gönder" : "E-posta Gönder"}
        </button>
      )}
    </span>
  );
}
